export const schoolFileRoutes = [
  {
    path: "/schoolfile/create",
    component: () => import("@/views/SchoolFileTransfer/Create.vue"),
  },
  {
    path: "/schoolfile/update/:fileid",
    component: () => import("@/views/SchoolFileTransfer/Create.vue"),
  },
  {
    path: "/schoolfile",
    component: () => import("@/views/SchoolFileTransfer/List.vue"),
  },
];
